import React, { Component } from 'react';
import PropTypes from "prop-types";

class Highlight extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        about: PropTypes.string.isRequired
    };
      
    render() {
        const { title, about } = this.props;

        if( title === "" ){
            return (<span />);
        } else {
            return (
                <div>
                    <div className="container">
                        <div className="jumbotron highlight">
                            <h3 className="display-8 center">{title}</h3>
                            <hr className="my-4" />
                            <p className="highlight-about">
                                {about}
                            </p>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default Highlight;


// WEBPACK FOOTER //
// ./src/components/highlight.jsx